import { ZoomIn, ZoomOut } from "lucide-react";
import { Slider } from "../../../ui/common-ui/slider";

interface ZoomControlsProps {
  zoom: number;
  minZoom: number;
  maxZoom: number;
  onZoomChange: (zoom: number) => void;
}

export function ZoomControls({ zoom, minZoom, maxZoom, onZoomChange }: ZoomControlsProps) {
  // Convert zoom (0.2-3) to slider value (0-100)
  const zoomToSlider = (z: number) => {
    return ((z - minZoom) / (maxZoom - minZoom)) * 100;
  };

  // Convert slider value (0-100) to zoom (0.2-3)
  const sliderToZoom = (value: number) => {
    return minZoom + (value / 100) * (maxZoom - minZoom);
  };

  const handleSliderChange = (values: number[]) => {
    const newZoom = sliderToZoom(values[0]);
    onZoomChange(newZoom);
  };

  return (
    <div className="fixed left-6 bottom-6 z-20 flex flex-row items-center gap-3 bg-card backdrop-blur-md rounded-lg p-3 shadow-lg">
      <ZoomOut className="h-4 w-4 text-muted-foreground" />

      <div className="w-32 flex items-center">
        <Slider
          value={[zoomToSlider(zoom)]}
          onValueChange={handleSliderChange}
          min={0}
          max={100}
          step={1}
          orientation="horizontal"
          className="w-full"
        />
      </div>

      <ZoomIn className="h-4 w-4 text-muted-foreground" />

      <div className="text-xs text-muted-foreground font-mono">
        {Math.round(zoom * 100)}%
      </div>
    </div>
  );
}
